<template>
    <div>

        <div style="margin-bottom: 1rem">
            <el-button size="mini" @click="handleAdd" type="info">添加</el-button>
        </div>

        <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column
                prop="domain"
                label="域名"
                width="120">
            </el-table-column>
            <el-table-column
                prop="store_id"
                label="店铺ID"
                width="130">
            </el-table-column>
            <el-table-column
              prop="api_key"
              label="API Key">
              <template slot-scope="scope">
                  <span style="font-family: monospace; color: #909399; font-size: 11px;">{{ scope.row.api_key }}</span>
              </template>
          </el-table-column>
          <el-table-column
              prop="password"
              label="Password">
              <template slot-scope="scope">
                  <span style="font-family: monospace; color: #909399; font-size: 11px;">{{ scope.row.password }}</span>
              </template>
          </el-table-column>
          <el-table-column
              prop="alias"
              label="别名"
              width="120">
          </el-table-column>
          <el-table-column
              prop="version"
              label="版本"
              width="80">
              <template slot-scope="scope">
                  <el-tag :type="scope.row.version === 'v2' ? 'success' : 'info'" size="mini">
                      {{ scope.row.version || 'v1' }}
                  </el-tag>
              </template>
          </el-table-column>
          <el-table-column
              prop="service_email"
              label="客服邮箱">
          </el-table-column>
          <el-table-column
              prop="email_password"
              label="邮箱密码">
              <template slot-scope="scope">
                  <span style="font-family: monospace; color: #909399; font-size: 11px;">{{ scope.row.email_password }}</span>
              </template>
          </el-table-column>
            <el-table-column
                prop="created_at"
                label="添加时间"
                width="130">
                <template slot-scope="scope">
                    {{ $moment(scope.row.created_at).format("YYYY-MM-DD") }}
                    <br>{{ $moment(scope.row.created_at).format("HH:mm:ss") }}
                </template>
            </el-table-column>

            <el-table-column
                prop="updated_at"
                label="修改时间"
                width="130">
                <template slot-scope="scope">
                    {{ $moment(scope.row.updated_at).format("YYYY-MM-DD") }}
                    <br>{{ $moment(scope.row.updated_at).format("HH:mm:ss") }}
                </template>
            </el-table-column>

            <el-table-column
                label="操作"
                width="180">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current_page"
            :page-size="per_page"
            :page-sizes="[20, 30, 50,100]"
            :pager-count="11"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>


        <!-- Form -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
            <div v-if="isEdit" style="background: #f5f7fa; padding: 10px; margin-bottom: 15px; border-radius: 4px; font-size: 12px; color: #606266;">
                <i class="el-icon-info"></i> 提示：API Key、Password、邮箱密码 留空将保持原有值不变。表格中显示的是脱敏数据，实际存储的是完整信息。
            </div>
            <el-form :model="form">
                <el-form-item label="域名">
                    <el-input v-model="form.domain" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="API版本">
                    <el-radio-group v-model="form.version">
                        <el-radio label="v1">V1 (ApiKey + Password)</el-radio>
                        <el-radio label="v2">V2 (Client ID + Client Secret)</el-radio>
                    </el-radio-group>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">
                        V2版本：API Key填写Client ID，Password填写Client Secret
                    </div>
                </el-form-item>
                <el-form-item :label="isEdit ? 'ApiKey (可选)' : 'ApiKey'">
                    <el-input v-model="form.api_key" autocomplete="off" 
                        :placeholder="isEdit ? `留空保持原值: ${maskedData.api_key}` : (form.version === 'v2' ? '请输入Client ID' : '请输入ApiKey')"></el-input>
                </el-form-item>
                <el-form-item :label="isEdit ? 'Password (可选)' : 'Password'">
                    <el-input v-model="form.password" autocomplete="off" type="password"
                        :placeholder="isEdit ? `留空保持原值: ${maskedData.password}` : (form.version === 'v2' ? '请输入Client Secret' : '请输入Password')"></el-input>
                </el-form-item>
              <el-form-item label="别名">
                <el-input v-model="form.alias" autocomplete="off"></el-input>
              </el-form-item>
                <el-form-item label="客服邮箱">
                    <el-input v-model="form.service_email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="isEdit ? '邮箱密码 (可选)' : '邮箱密码'">
                    <el-input v-model="form.email_password" autocomplete="off" type="password"
                        :placeholder="isEdit ? `留空保持原值: ${maskedData.email_password}` : '请输入邮箱密码'"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click=submit>确 定</el-button>
            </div>
        </el-dialog>

    </div>


</template>

<script>

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18

Date.prototype.Format = function (fmt) { // author: meizz
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default {
    name: "Index",
    data() {
        return {
            current_page: 1,//当前页
            per_page: 20,//每页数量
            total: 0,//总数
            tableData: [],

            dialogFormVisible: false,
            dialogTitle: '添加店铺',
            isEdit: false,
            editIndex: -1,

            form: {
                id: null,
                domain: "",
                api_key: "",
                password: "",
                alias: "",
                service_email: "",
                email_password: "",
                version: "v1"
            },

            // 存储当前编辑记录的脱敏数据，用于placeholder显示
            maskedData: {
                api_key: "",
                password: "",
                email_password: ""
            }

        }
    },
    methods: {

        setSubmit() {
            this.getTableData(1, this.per_page)
        },

        // 获取表格数据
        getTableData(page, limit) {

            let param = {
                page: page,
                limit: limit,
            };

            console.log(param)

            this.http.fetchGet(this.api.shop_list, param).then((res) => {
                if (res.data.code === 200) {
                    let data = res.data.data;
                    console.log(data)

                    this.total = data.total;
                    this.current_page = data.current_page;

                    this.tableData = data.data
                }
                if (res.data.code === 201) {
                    let url = res.data.data.url;
                    window.open(url)
                }

            }).catch(err => {
                console.log(err)
            })
        },

        //分页改变...
        handleCurrentChange(val) {
            // this.current_page=val
            this.getTableData(val, this.per_page)
        },
        handleSizeChange(val) {

            this.per_page = val;
            //返回第一页
            this.handleCurrentChange(1);
        },

        // 添加店铺
        handleAdd() {
            this.resetForm();
            this.dialogFormVisible = true;
        },

        //添加或修改
        submit() {
            if (this.isEdit) {
                // 修改店铺
                this.http.fetchPut(this.api.shop_update, this.form).then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.$message.success('修改成功');
                        this.dialogFormVisible = false;
                        this.getTableData(this.current_page, this.per_page);
                        this.resetForm();
                    } else {
                        this.$message.error(data.message)
                    }
                }).catch(err => {
                    console.log(err)
                })
            } else {
                // 添加店铺
                this.http.fetchPost(this.api.shop_create, this.form).then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.$message.success('添加成功');
                        this.dialogFormVisible = false;
                        this.getTableData(1, this.per_page);
                        this.resetForm();
                    } else {
                        this.$message.error(data.message)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        },

        // 重置表单
        resetForm() {
            this.form = {
                id: null,
                domain: "",
                api_key: "",
                password: "",
                alias: "",
                service_email: "",
                email_password: "",
                version: "v1"
            };
            // 重置脱敏数据
            this.maskedData = {
                api_key: "",
                password: "",
                email_password: ""
            };
            this.isEdit = false;
            this.editIndex = -1;
            this.dialogTitle = '添加店铺';
        },

        // 修改店铺
        handleEdit(index, row) {
            this.isEdit = true;
            this.editIndex = index;
            this.dialogTitle = '修改店铺';
            this.form = {
                id: row.id,
                domain: row.domain,
                api_key: '',  // 出于安全考虑，敏感信息不显示原值，留空表示保持原值
                password: '', // 出于安全考虑，敏感信息不显示原值，留空表示保持原值
                alias: row.alias || '',
                service_email: row.service_email,
                email_password: '', // 出于安全考虑，敏感信息不显示原值，留空表示保持原值
                version: row.version || 'v1'
            };
            // 存储脱敏数据用于placeholder显示
            this.maskedData.api_key = row.api_key || '';
            this.maskedData.password = row.password || '';
            this.maskedData.email_password = row.email_password || '';
            this.dialogFormVisible = true;
        },

        // 删除店铺
        handleDelete(index, row) {
            this.$confirm(`此操作将永久删除店铺 "${row.domain}", 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.http.fetchDel(this.api.shop_delete + '/' + row.id).then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.$message.success('删除成功');
                        this.getTableData(this.current_page, this.per_page);
                    } else {
                        this.$message.error(data.message)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        }

    },
    mounted() {
        this.getTableData(this.current_page, this.per_page)
    }
}
</script>

<style scoped lang="stylus">
.header-checkbox
    //text-align center
    margin .5rem 0

.el-radio-group
    display block
    margin-bottom 1rem
</style>
